/*
 * Author: Harper Yan
 * File Created: Wednesday, 24-07-10 03:10 pm
 * Last Modified: Thursday, 24-07-11 09:38 pm, by Harper Yan
 */

import { useStore } from 'zustand';

import { default as snackbarStore, SnackbarState } from './store';

export function useSnackbarStore(): SnackbarState;
export function useSnackbarStore<T>(selector: (state: SnackbarState) => T): T;
export function useSnackbarStore<T>(selector?: (state: SnackbarState) => T) {
  return useStore(snackbarStore, selector!);
}
